import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addVRApp: false,
  editVRApp: false,
  editMode: false,

  application_id: null,
  application_name: null,
  application_intended_device: null,
  application_provider: null,
  application_description: null,
  application_status: null,
  application_OS: null,
  application_bu: null,
  application_division: null,
  application_edit: false,
  applicationIsPane: false,
  addapplicationIsPane: false,
  application_filter: true,
  bu_edit: false,
};

export const applicationVR_ReducerInner = createSlice({
  name: "applicationVR",
  initialState: initialState,
  reducers: {
    add_VR_App(state, action) {
      state.addVRApp = action.payload;
    },
    edit_VR_App(state, action) {
      state.editVRApp = action.payload;
    },
    edit_Mode(state, action) {
      state.editMode = action.payload;
    },
    application_id(state, action) {
      state.application_id = action.payload;
    },
    application_name(state, action) {
      state.application_name = action.payload;
    },
    application_intended_device(state, action) {
      state.application_intended_device = action.payload;
    },
    application_provider(state, action) {
      state.application_provider = action.payload;
    },
    application_description(state, action) {
      state.application_description = action.payload;
    },
    application_OS(state, action) {
      state.application_OS = action.payload;
    },
    application_status(state, action) {
      state.application_status = action.payload;
    },
    application_bu(state, action) {
      state.application_bu = action.payload;
    },
    application_division(state, action) {
      state.application_division = action.payload;
    },
    application_edit(state, action) {
      state.application_edit = action.payload;
    },
    application_IsPane(state, action) {
      state.applicationIsPane = action.payload;
    },
    addapplication_IsPane(state, action) {
      state.addapplicationIsPane = action.payload;
    },
    application_filter(state, action) {
      state.application_filter = action.payload;
    },
    bu_edit(state, action) {
      state.bu_edit = action.payload;
    },
  },
});
